/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import Quill from 'quill';
import classnames from 'classnames';
import extend from 'lodash/extend';
import bindAll from 'lodash/bindAll';
import data from '@emoji-mart/data';
import { init, SearchIndex } from 'emoji-mart';
import each from 'lodash/each';
import pick from 'lodash/pick';
import './quillEmojiBlot';
import styles from '../styles/quillEmoji.module.scss';

function Emoji(quill, options) {
  init({ data });
  this.quill = quill;
  this.options = options;
  extend(Emoji.prototype, emoji);
  bindAll(this, ...Object.keys(Emoji.prototype));
  this.setupElement();
  this.setupKeyboardBindings();
}

const emoji = {

  setupElement() {
    const { emojiPickerPosition } = this.options;
    this.element = document.createElement('ul');
    this.element.className = classnames(styles.list, {
      [styles.isBottom]: emojiPickerPosition === 'bottom',
    });
    this.quill.container.appendChild(this.element);
  },

  setupKeyboardBindings() {
    // On colon pressed
    this.quill.keyboard.addBinding({
      key: 186,
      shiftKey: true,
    }, (range, context) => {
      const prevChar = context.prefix[context.prefix.length - 1];
      if (prevChar === ' ' || !prevChar) {
        this.enablePicker(range);
      }
      return true;
    });

    // On colon pressed for Firefox
    this.quill.keyboard.addBinding({
      key: 59,
      shiftKey: true,
    }, (range, context) => {
      const prevChar = context.prefix[context.prefix.length - 1];
      if (prevChar === ' ' || !prevChar) {
        this.enablePicker(range);
      }
      return true;
    });

    // on space pressed
    this.quill.keyboard.addBinding({
      key: 32,
      shifKey: false,
    }, () => {
      if (this.isVisible || this.isEnabled) {
        this.disablePicker();
      }
      return true;
    });

    // On down key pressed
    this.quill.keyboard.addBinding({
      key: 40,
      shiftKey: false,
    }, () => {
      if (!this.isVisible) return true;
      if (this.filteredEmojis && this.filteredEmojis.length) {
        if (this.selectedIndex === this.filteredEmojis.length - 1) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex++;
        }
        this.selectedEmoji = this.filteredEmojis[this.selectedIndex];
        this.renderEmojis();
      }
      return false;
    });

    // On up key pressed
    this.quill.keyboard.addBinding({
      key: 38,
      shiftKey: false,
    }, () => {
      if (!this.isVisible) return true;
      if (this.filteredEmojis && this.filteredEmojis.length) {
        if (this.selectedIndex === 0) {
          this.selectedIndex = this.filteredEmojis.length - 1;
        } else {
          this.selectedIndex--;
        }
        this.selectedEmoji = this.filteredEmojis[this.selectedIndex];
        this.renderEmojis();
      }
      return false;
    });
  },

  enablePicker(range) {
    this.isEnabled = true;
    this.searchValue = '';
    this.selectedIndex = 0;
    this.emojiRangeIndex = range.index;
    this.emojiBounds = this.quill.getBounds(range);
    this.renderEmojis();
    this.positionPicker();
    this.quill.on('text-change', this.onTextChange);
    return true;
  },

  disablePicker() {
    this.isEnabled = false;
    this.element.classList.remove(styles.isEnabled);
    this.quill.off('text-change', this.onTextChange);
    this.quill.focus();
  },

  positionPicker() {
    const pickerList = document.getElementsByClassName(styles.list)[0];

    const leftValue = this.emojiBounds.left - 100 > 0 ? this.emojiBounds.left - 100 : 0;

    pickerList.style.left = `${leftValue}px`;
    pickerList.style.marginBottom = `-${this.emojiBounds.bottom - 24}px`;
  },

  showEmojis() {
    this.isVisible = true;
    this.element.classList.add(styles.isEnabled);
    this.renderEmojis();
  },

  hideEmojis() {
    this.isVisible = false;
    this.element.classList.remove(styles.isEnabled);
  },

  async onTextChange() {
    const selectionIndex = this.quill.getSelection().index;
    // If the user deletes the semi colon
    this.selectedIndex = 0;
    if (this.emojiRangeIndex >= selectionIndex) {
      return this.disablePicker();
    }
    // ensures that if you want to type something like :) it will not search for `)` as it comes after the colon
    this.searchValue = this.quill.getText(this.emojiRangeIndex + 1, selectionIndex - this.emojiRangeIndex - 1).replace(/[!?()-]/g, '');
    this.selectedIndex = 0;
    if (this.searchValue.length > 0) {
      const emojis = await SearchIndex.search(this.searchValue);
      this.filteredEmojis = emojis.map(({ skins }) => skins[0]);
      this.showEmojis();
    } else {
      this.hideEmojis();
    }
  },

  onSelectEmoji() {
    if (!this.selectedEmoji) {
      this.hideEmojis();
      this.disablePicker();
      return;
    }
    this.quill.deleteText(this.emojiRangeIndex, this.searchValue.length + 1, Quill.sources.USER);
    this.quill.insertEmbed(this.emojiRangeIndex, 'emoji', pick(this.selectedEmoji, ['native']), Quill.sources.USER);
    setTimeout(() => this.quill.setSelection(this.emojiRangeIndex + 1), 0);
    this.quill.focus();
    this.disablePicker();
    this.hideEmojis();
  },

  renderEmojis() {
    while (this.element.firstChild) {
      this.element.firstChild.remove();
    }

    if (this.filteredEmojis && this.filteredEmojis.length) {
      this.selectedEmoji = this.filteredEmojis[this.selectedIndex];
    } else {
      this.selectedEmoji = null;
    }
    each(this.filteredEmojis, (emojiItem, index) => {
      let className = styles.item;
      if (index === this.selectedIndex) {
        className += ` ${styles.isSelected}`;
      }
      const li = renderElement({
        tag: 'li',
        className,
        children: [{
          tag: 'button',
          className: styles.itemButton,
          attributes: {
            type: 'button',
          },
          children: [{
            tag: 'span',
            children: [emojiItem.native],
          }, {
            tag: 'span',
            children: [emojiItem.shortcodes],
          }],
        }],
      });
      this.element.appendChild(li);
      const button = li.firstChild;
      button.addEventListener('mousedown', () => {
        this.selectedIndex = index;
        this.selectedEmoji = this.filteredEmojis[this.selectedIndex];
        this.onSelectEmoji();
      });
    });

    const selectedChild = this.element.childNodes[this.selectedIndex];

    if (selectedChild) {
      if (selectedChild.scrollIntoViewIfNeeded) {
        selectedChild.scrollIntoViewIfNeeded();
      } else {
        selectedChild.scrollIntoView({ behavior: 'auto', block: 'nearest' });
      }
    }
  },

};

function renderElement({
  tag, className, attributes = {}, children = [],
}) {
  const element = document.createElement(tag);
  if (className) {
    element.className = className;
  }
  Object.keys(attributes).forEach(key => element[key] = attributes[key]);
  children.forEach((child) => {
    if (typeof child === 'string') {
      child = document.createTextNode(child);
      element.appendChild(child);
    } else {
      element.appendChild(renderElement(child));
    }
  });
  return element;
}

Quill.register('modules/emoji', Emoji);
